/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Report_Total_ExpenseInputs */

const vi_expense_report_total_expense = /** @type {(inputs: Expense_Report_Total_ExpenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng chi`)
};

/**

* @param {Expense_Report_Total_ExpenseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_report_total_expense = /** @type {((inputs?: Expense_Report_Total_ExpenseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Report_Total_ExpenseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_report_total_expense(inputs)
});